import React, { useCallback, useEffect, useState } from "react";
import { Button, Icon } from "semantic-ui-react";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";

import swal from "sweetalert";
import Form from "../../../components/General/Form";
import * as FormTemplateAdmin from "../../../components/General/Form/templates/admin";
import { useRouter } from "../../../hooks/router";
import { producaov2 as api } from "../../../services/apis";
import { getUserNode } from "../../../services/auth_node";
import { limpaTituloCurso } from "../../../utils/Utils";
import {
  AmeIcon,
  Card,
  CardsContainer,
  Container,
  Content,
  CursosContainer,
  FormContainer,
  PaymentContainer,
  TextValue,
  Title,
} from "./styles";

import { FaAddressBook, FaAddressCard, FaCheck } from "react-icons/fa";

import Modal from "../../../components/Modal";
import HeaderModal from "../../../components/Modal/Header";
import FooterModal from "../../../components/Modal/Footer";
import { ModalButton } from "../../../components/Modal/styles";
import { CgClose, CgPaypal } from "react-icons/cg";
import { toast } from "react-toastify";
import { Box } from "@material-ui/core";
import { creditCardInstallments } from "../../../constants";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";

const getInitialValidadeDate = () => {
  const initialValidade = new Date();
  initialValidade.setHours(23, 59, 59);
  return initialValidade;
};

const convertDateToInputDateTimeLocal = (validade) => {
  if (!validade || !(validade instanceof Date) || Number.isNaN(validade.getTime())) {
    return null;
  }
  const year = validade.getFullYear();
  const month = (validade.getMonth() + 1).toString().padStart(2, 0);
  const day = validade.getDate().toString().padStart(2, 0);
  const hour = validade.getHours().toString().padStart(2, 0);
  const minute = validade.getMinutes().toString().padStart(2, 0);
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

const convertDateToInputDate = (validade) => {
  if (!validade || !(validade instanceof Date) || Number.isNaN(validade.getTime())) {
    return null;
  }
  const year = validade.getFullYear();
  const month = (validade.getMonth() + 1).toString().padStart(2, '0');
  const day = validade.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const calculateDaysDifference = (targetDate) => {
  if (!targetDate) return null;
  const today = new Date();
  today.setHours(12, 0, 0, 0);
  
  const [year, month, day] = targetDate.split('-').map(Number);
  const target = new Date(year, month - 1, day, 12, 0, 0, 0);
  
  const diffTime = Math.abs(target - today);
  const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24)) + 1;
  return diffDays;
};

const oneYearFromNow = new Date();
oneYearFromNow.setFullYear(new Date().getFullYear() + 1);
oneYearFromNow.setHours(23, 59, 59, 0);

// Código secreto do link de uso único (ids de pedido são sequenciais) — spec VGE 2026-10-14, E2.
const gerarCodigoLink = () => {
  const bytes = new Uint8Array(9);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(36).padStart(2, "0")).join("").slice(0, 16);
};

const Pagamentos = () => {
  const [aluno, setAluno] = useState({});
  const [cursos, setCursos] = useState([]);
  const [metodo, setMetodo] = useState("escolha");
  const [valorTotal, setValorTotal] = useState("");
  const [cursosOptions, setCursosOptions] = useState([]);
  const [pedidoTipo, setPedidoTipo] = useState(5);
  const [modalOpen, setModalOpen] = useState(false);
  const [parcelsLimit, setParcelsLimit] = useState(12);
  const [checkIncompany, setCheckIncompany] = useState(false);
  const [idPedido, setIdPedido] = useState();
  const [codigoLink, setCodigoLink] = useState(null);
  const [pedidoGerado, setPedidoGerado] = useState();
  const [qrCodeData, setQrCodeData] = useState(null);
  const [dataValidade, setDataValidade] = useState(getInitialValidadeDate);
  const [dataValidadeCurso, setDataValidadeCurso] = useState(convertDateToInputDate(oneYearFromNow));
  const [isNotDataValidadeCurso, setIsNotDataValidadeCurso] = useState(false);
  const [isCustomCourseValidity, setIsCustomCourseValidity] = useState(false);
  const [isNotDataValidade, setIsNotDataValidade] = useState(false);

  const router = useRouter();

  const returnNamesCourses = useCallback(() => {
    return Promise.all(
      cursos.map((curso) => {
        return api.get(`/cursolist/${curso.id}`);
      }),
    ).then((cursosTitulos) => {
      return cursosTitulos.map(({ data: { titulo } }) =>
        limpaTituloCurso(titulo),
      );
    });
  }, [cursos]);

  const pedidoJsonCreate = useCallback(
    (cursosPedido, total = 0, id_pedido, pc = false) => {
      const pedido = {};

      pedido.cartID = "link_gerado";
      pedido.cupom = "";
      pedido.tipo = pedidoTipo;
      pedido.cursos =
        pc || Array.isArray(cursosPedido) ? cursosPedido : [cursosPedido];
      pedido.descontoStr = "";
      pedido.desconto = 0;
      pedido.obs = "";
      pedido.pagamento = metodo;
      pedido.parcelas = parcelsLimit;
      pedido.pessoa = aluno.id;
      pedido.total = total;
      pedido.valor_parcela = (total / parcelsLimit).toFixed(2);
      if (isCustomCourseValidity) {
        if (isNotDataValidadeCurso) {
          pedido.dias_validade_curso = 180;
        } else if (dataValidadeCurso) {
          pedido.dias_validade_curso = calculateDaysDifference(dataValidadeCurso);
        }
      }

      if (!isNotDataValidade) {
        pedido.dataValidadePedido = dataValidade;
      }

      return {
        data: new Date(),
        status: 70,
        tipo: pedidoTipo,
        obs: "",
        valor_parcela: pedido.valor_parcela,
        json: JSON.stringify(pedido),
        tipo_pagamento: "LINK GERADO",
        id_pedido,
      };
    },
    [
      aluno,
      metodo,
      pedidoTipo,
      parcelsLimit,
      valorTotal,
      dataValidade,
      isNotDataValidade,
      isCustomCourseValidity,
      isNotDataValidadeCurso,
      dataValidadeCurso,
    ],
  );

  // Função para gerar PDF com QRCode
  const handleGeneratePDF = useCallback(
    async (qrCode, orderID, amount) => {
      const data = qrCode || qrCodeData;

      if (!data) return;

      try {
        // Criar novo documento PDF
        const pdfDoc = await PDFDocument.create();
        const form = pdfDoc.getForm();

        // Incorporar fonte padrão (Ajuda na compatibilidade do campo de texto)
        const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica);

        // Adicionar página
        const page = pdfDoc.addPage([595, 842]); // A4 size
        const { width, height } = page.getSize();

        // Definir tamanhos de fonte
        const fontSize = 20;
        const smallFontSize = 12;
        const tinyFontSize = 10;

        // Título
        page.drawText("Pagamento PIX - Voitto", {
          x: 50,
          y: height - 50,
          size: fontSize,
          color: rgb(0, 0, 0),
        });

        // Linha separadora topo
        page.drawLine({
          start: { x: 50, y: height - 60 },
          end: { x: width - 50, y: height - 60 },
          thickness: 1,
          color: rgb(0, 0, 0),
        });

        // --- Informações do pedido ---
        let yPosition = height - 90;

        page.drawText("Informações do Pedido", {
          x: 50,
          y: yPosition,
          size: smallFontSize,
          color: rgb(0, 0, 0),
        });

        yPosition -= 25;
        page.drawText(`Pedido: #${orderID}`, {
          x: 50,
          y: yPosition,
          size: smallFontSize,
          color: rgb(0, 0, 0),
        });

        yPosition -= 20;
        page.drawText(`Aluno: ${aluno.nome}`, {
          x: 50,
          y: yPosition,
          size: smallFontSize,
          color: rgb(0, 0, 0),
        });

        yPosition -= 20;
        page.drawText(`Email: ${aluno.email}`, {
          x: 50,
          y: yPosition,
          size: smallFontSize,
          color: rgb(0, 0, 0),
        });

        yPosition -= 20;
        page.drawText(`${String(aluno.cpf || "").replace(/\D/g, "").length === 14 ? "CNPJ" : "CPF"}: ${aluno.cpf || "Não informado"}`, {
          x: 50,
          y: yPosition,
          size: smallFontSize,
          color: rgb(0, 0, 0),
        });

        yPosition -= 20;
        page.drawText(`Valor: R$ ${amount}`, {
          x: 50,
          y: yPosition,
          size: smallFontSize,
          color: rgb(0, 0, 0),
        });

        yPosition -= 20;
        const statusText =
          data.status === "waitingPayment"
            ? "Aguardando Pagamento"
            : data.status;
        page.drawText(`Status: ${statusText}`, {
          x: 50,
          y: yPosition,
          size: smallFontSize,
          color: rgb(0, 0, 0),
        });

        yPosition -= 15;
        page.drawLine({
          start: { x: 50, y: yPosition },
          end: { x: width - 50, y: yPosition },
          thickness: 1,
          color: rgb(0, 0, 0),
        });

        yPosition -= 30;
        page.drawText("Código PIX Copia e Cola", {
          x: 50,
          y: yPosition,
          size: smallFontSize,
          color: rgb(0, 0, 0),
        });

        if (data.qrCode?.image) {
          try {
            const pixCode = data.qrCode.url;
            const publicApiUrl = `https://quickchart.io/qr?text=${encodeURIComponent(
              pixCode,
            )}&size=300&margin=1&ecLevel=M`;

            const response = await fetch(publicApiUrl);

            if (response.ok) {
              const imageBytes = await response.arrayBuffer();
              const contentType = response.headers.get("content-type");

              let qrImage;

              if (contentType && contentType.includes("jpeg")) {
                qrImage = await pdfDoc.embedJpg(imageBytes);
              } else {
                qrImage = await pdfDoc.embedPng(imageBytes);
              }

              yPosition -= 180; // Espaço reservado para a imagem
              page.drawImage(qrImage, {
                x: (width - 150) / 2,
                y: yPosition,
                width: 150,
                height: 150,
              });

              yPosition -= 20;
              const textInstruction = "Escaneie o QR Code acima para pagar";
              const textWidth = helvetica.widthOfTextAtSize(
                textInstruction,
                10,
              );
              page.drawText("Escaneie o QR Code acima para pagar", {
                x: (width - textWidth) / 2,
                y: yPosition,
                size: 10,
                color: rgb(0, 0, 0),
              });
            } else {
              console.warn("Imagem não acessível, gerando PDF sem ela.");
            }
          } catch (error) {
            console.error(
              "Erro ao processar imagem do QR Code (PDF será gerado sem imagem):",
              error,
            );
          }
        }

        // --- LÓGICA DO CAMPO DE TEXTO ---

        // Texto de instrução
        yPosition -= 40;
        page.drawText("Ou copie o código abaixo:", {
          x: 50,
          y: yPosition,
          size: tinyFontSize,
          color: rgb(0, 0, 0),
        });

        // Configuração da caixa de texto
        const boxHeight = 60;
        const margin = 10;

        // Ajuste crucial de posição: descemos a altura da caixa + margem
        yPosition -= boxHeight + margin;

        const pixCode = data.qrCode.url;
        const textField = form.createTextField("pixCodeField");

        textField.setText(pixCode);

        // Desenha o campo na página
        textField.addToPage(page, {
          x: 50,
          y: yPosition,
          width: width - 100,
          height: boxHeight,
          textColor: rgb(0, 0, 0),
          backgroundColor: rgb(0.95, 0.95, 0.95), // Fundo cinza claro
          borderColor: rgb(0.8, 0.8, 0.8),
          borderWidth: 1,
        });

        // Configurações do campo
        textField.setFontSize(8); // Fonte pequena para caber mais caracteres
        textField.enableMultiline(); // Permite quebra visual

        // Atualiza a aparência usando a fonte Helvetica (corrige bugs de clique)
        textField.updateAppearances(helvetica);

        // Rodapé
        page.drawText(`Gerado em: ${new Date().toLocaleString("pt-BR")}`, {
          x: width / 2 - 80,
          y: 30,
          size: 9,
          color: rgb(0.5, 0.5, 0.5),
        });

        // Salvar e Baixar PDF
        const pdfBytes = await pdfDoc.save();
        const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });
        const pdfFile = new File([pdfBlob], `qrcode-pix-pedido-${orderID}.pdf`);

        const anchorElement = document.createElement("a");
        anchorElement.style.display = "none";
        anchorElement.href = URL.createObjectURL(pdfFile);
        anchorElement.download = pdfFile.name;

        document.body.appendChild(anchorElement);
        anchorElement.click();

        setTimeout(() => {
          URL.revokeObjectURL(anchorElement.href);
          anchorElement.parentNode.removeChild(anchorElement);
        }, 0);

        toast.success("PDF gerado com sucesso!");
      } catch (error) {
        console.error("Erro ao gerar PDF:", error);
        swal(
          "Erro ao gerar PDF",
          "Houve um erro ao gerar o PDF do QRCode",
          "error",
        );
      }
    },
    [qrCodeData, aluno],
  );

  const handleCopyPixCode = useCallback(
    (qrCode) => {
      const data = qrCode || qrCodeData;
      if (data?.qrCode?.url) {
        navigator.clipboard.writeText(data.qrCode.url);
        toast.success("Código PIX copiado para a área de transferência!");
      }
    },
    [qrCodeData],
  );

  const openPixModal = useCallback(
    (data, amount, orderID) => {
      swal({
        title: "QRCode PIX gerado com sucesso!",
        text: "O que deseja fazer?",
        icon: "success",
        buttons: {
          copy: {
            text: "Copiar Código PIX",
            value: "copy",
            visible: true,
            closeModal: false,
          },
          pdf: {
            text: "Gerar PDF",
            value: "pdf",
            visible: true,
            closeModal: false,
          },
          cancel: {
            text: "Fechar",
            value: null,
            visible: true,
            closeModal: true,
          },
        },
      }).then(async (value) => {
        if (value === "copy") {
          handleCopyPixCode(data);
          swal.stopLoading();
          setTimeout(() => openPixModal(data, amount, orderID), 200);
        } else if (value === "pdf") {
          await handleGeneratePDF(data, orderID, amount);
          swal.stopLoading();
          setTimeout(() => openPixModal(data, amount, orderID), 200);
        }
      });
    },
    [handleCopyPixCode, handleGeneratePDF],
  );

  // A regra mora no servidor (voittoapi helpers/pagarmeCustomer) — uma só para admin, site e VGE.
  // Devolve a lista do que falta, ou null se a conferência falhou (o aviso de erro já foi mostrado).
  const conferirCadastro = useCallback(async (idPessoa) => {
    try {
      const { data } = await api.post("/admin/pagarme/conferir-cadastro", { id_pessoa: idPessoa });
      return data?.faltando || [];
    } catch (err) {
      swal.close();
      setTimeout(() => {
        swal("Não foi possível conferir o cadastro", err?.response?.data?.message || "Tente novamente.", "error");
      }, 100);
      return null;
    }
  }, []);

  const createQrCode = useCallback(
    async (pedido) => {
      const missing = await conferirCadastro(aluno.id);
      if (missing === null) return;
      if (missing.length > 0) {
        swal.close();
        setTimeout(() => {
          swal(
            "Não é possível gerar o QRCode PIX",
            `A Pagar.me exige os campos abaixo no cadastro do aluno antes de gerar o PIX:\n\n• ${missing.join(
              "\n• "
            )}\n\nAtualize o cadastro do aluno e tente novamente.`,
            "warning"
          );
        }, 100);
        return;
      }

      try {
        const pedidoJson = JSON.parse(pedido.json);
        const orderID = pedido.id;

        const payload = {
          orderID,
          id_pessoa: aluno.id,
          email: aluno.email,
          name: aluno.nome,
          cpf: aluno.cpf,
          payment: {
            id: pedidoJson.tipo,
          },
          address: {
            street: aluno.endereco,
            number: aluno.numero,
            neighborhood: aluno.bairro,
            city: aluno.cidade,
            state: aluno.estado,
            zipCode: aluno.cep,
          },
          courseID: Number(pedidoJson.cursos[0].id),
          amount: pedidoJson.total,
        };

        const response = await api.post("/admin/order-pix-request", payload);

        // A API responde 200 com status 'failed' quando a Pagar.me não gera o PIX: nunca mostrar sucesso sem QR.
        if (response.data?.status === "failed" || !response.data?.qrCode?.url) {
          swal("Erro ao gerar QRCode", response.data?.message || "A Pagar.me não gerou o PIX.", "error");
          return;
        }
        setQrCodeData(response.data);
        openPixModal(response.data, pedidoJson.total, orderID);
      } catch (error) {
        console.error("Erro ao gerar QRCode:", error);
        swal(
          "Erro ao gerar QRCode",
          error?.response?.data?.message ||
            "Houve um erro ao gerar o QRCode PIX",
          "error",
        );
      }
    },
    [aluno, openPixModal, conferirCadastro],
  );

  // Atualizar a função showLinkPagamento
  const showLinkPagamento = async (idPedido, pedido) => {
    const pedidoJson = JSON.parse(pedido.json);
    const baseUrl = checkIncompany
      ? `https://www.voitto.com.br/inscricao-especial`
      : "https://www.voitto.com.br/inscricao/pagar";
    const url = checkIncompany
      ? `${baseUrl}/incompany?id=${idPedido}`
      : `${baseUrl}/${idPedido}${pedidoJson.codigo ? `?c=${pedidoJson.codigo}` : ""}`;
    return swal({
      title: "Link de pagamento",
      text: pedidoJson.usoUnico
        ? `${url}\n\nQualquer conta pode pagar este link e o curso vai para quem pagar. Ele aceita um único pagamento.`
        : url,
      buttons: {
        copy: { text: "Copiar link", closeModal: false },
        qrcode: {
          text: "Gerar QRCode PIX",
          value: "createQrcode",
          visible: pedidoJson.pagamento === "pix" ? true : false,
          closeModal: false,
        },
      },
    }).then((value) => {
      if (value === "copy") {
        navigator.clipboard.writeText(url);
        toast.success(
          "Link copiado para a área de transferência, agora é só colar no local desejado",
        );
        swal.stopLoading();
      } else if (value === "createQrcode") {
        createQrCode(pedido);
      }
    });
  };

  const gerarLink = useCallback(async () => {
    const materiais = [];
    const certificados = [];
    const pedidosSeparados = [];

    try {
      await api.put(`admin/eadalunos/${aluno.id}`, { aluno });
    } catch (err) {
      swal("Não foi possível salvar o cadastro do aluno", err?.response?.data?.message || "Tente novamente.", "error");
      return;
    }

    if (["pix", "cartao_de_credito", "escolha"].includes(metodo)) {
      const missing = await conferirCadastro(aluno.id);
      if (missing === null) return;
      if (missing.length > 0) {
        swal(
          "Não é possível gerar o link de pagamento",
          `A Pagar.me exige no cadastro do aluno:\n\n• ${missing.join("\n• ")}\n\nAtualize o cadastro e tente novamente.`,
          "warning"
        );
        return;
      }
    }

    if (!dataValidade) {
      swal("Data de validade inválida", `Informe uma data válida`, "error");
      return;
    }

    // Validação da data de validade do curso
    if (isCustomCourseValidity && !isNotDataValidadeCurso) {
      if (!dataValidadeCurso) {
        swal("Data de validade do curso inválida", "Por favor, informe uma data de validade para o curso.", "error");
        return;
      }
      
      const [year, month, day] = dataValidadeCurso.split('-').map(Number);
      const selectedDate = new Date(year, month - 1, day);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      if (selectedDate <= today) {
        swal("Data de validade do curso inválida", "A data de validade do curso deve ser maior que a data de hoje.", "error");
        return;
      }
    }

    const valor_de_subitem = [];

    try {
      cursos.map((curso, index) => {
        const { material, certificado } = curso;
        const t = valorTotal.replace(",", ".");
        const valor = parseFloat(t).toFixed(2);

        if (isNaN(valor)) {
          swal("Valor incorreto", `Valor total do pedido incorreto`, "error");
          throw new Error();
        }

        if (
          material === false &&
          certificado === false &&
          (valor == 50 || valor == 97 || valor == 147)
        ) {
          valor_de_subitem.push(curso);
        }

        const materiaisCurrentCurso = [];
        const certificadoCurrentCurso = [];

        if (
          valor === undefined ||
          valor === null ||
          isNaN(valor) === true ||
          valor <= 1
        ) {
          swal(
            "Dados incompletos",
            `Informe um valor válido e maior que R$1.00 no item ${index + 1}`,
            "error",
          );
          throw new Error();
        }

        if (material) {
          materiais.push(curso.id);
          materiaisCurrentCurso.push(curso.id);
        }

        if (certificado) {
          certificados.push(curso.id);
          certificadoCurrentCurso.push(curso.id);
        }

        pedidosSeparados.push({
          cursoPedido: {
            id: curso.id,
            id_curso: curso.id,
            materiais: materiaisCurrentCurso,
            certificados: certificadoCurrentCurso,
            taxas: 0,
            cupom: "",
            desconto: 0,
            valorProduto: valor,
            listaEspera: false,
          },
          total: valor,
          materiais,
          certificados,
        });
      });
    } catch {
      return;
    }

    let prosseguir_subitems = true;

    if (valor_de_subitem.length > 0) {
      const name_courses_with_subitens = valor_de_subitem.map(
        (v) => v.id + ", ",
      );
      prosseguir_subitems = window.confirm(
        `Os curso(os) de id ${name_courses_with_subitens} estão com preços que aparentam estar direcionados a certificados ou materiais, porém não foi assinalado antes do envio. Tem certeza que deseja enviar o pedido?`,
      );
    }
    if (prosseguir_subitems === false) {
      return false;
    }

    const formatedCursosPedido = {
      id: cursos.map((curso) => curso.id).join(","),
      materiais: materiais.map((material) => material.toString()),
      certificados: certificados.map((certificado) => certificado.toString()),
    };

    const params = pedidoJsonCreate(formatedCursosPedido, valorTotal);

    // Link de uso único (spec E2): qualquer conta paga, o curso vai para quem pagou.
    // O link "in company" (rota antiga) fica de fora.
    if (!checkIncompany) {
      const pedidoJsonUsoUnico = JSON.parse(params.json);
      pedidoJsonUsoUnico.usoUnico = true;
      pedidoJsonUsoUnico.codigo = gerarCodigoLink();
      params.json = JSON.stringify(pedidoJsonUsoUnico);
    }

    try {
      const nameCourses = await returnNamesCourses();

      api
        .post("/admin/pedido_only/", params)
        .then(async (v) => {
          const pedido_id_recent = v.data.data.id;
          const pedido = v.data.data;
          setIdPedido(pedido_id_recent);
          // Código e id do pedido gravados juntos, só depois de o pedido existir.
          setCodigoLink(JSON.parse(pedido.json || "{}").codigo || null);
          const promisesPco = [];

          pedidosSeparados.map((v) => {
            const paramsCreate = v;
            const t = paramsCreate.total.replace(",", ".");
            paramsCreate.id_pedido = pedido_id_recent;
            promisesPco.push(
              api.post(
                "/admin/pessoa_curso_only/",
                pedidoJsonCreate(
                  paramsCreate.cursoPedido,
                  parseFloat(t).toFixed(2),
                  pedido_id_recent,
                  true,
                ),
              ),
            );
          });

          Promise.all(promisesPco)
            .then(async (promiseSolved) => {
              await showLinkPagamento(pedido_id_recent, pedido);
              let corpoEmail = [];
              promiseSolved.map((pedido, index) => {
                const li = `<li> ${nameCourses[index]} | Id Curso: ${
                  pedido.data.data.id_curso
                } | Valor: R$ ${
                  pedido.data.data.valor_pago
                } | Certificado Impresso: ${
                  pedido.data.data.CertificadoImpresso ? "Sim" : "Não"
                } | Material Impresso: ${
                  pedido.data.data.MaterialImpresso ? "Sim" : "Não"
                } | ID_pedido: ${pedido.data.data.id_pedido} | Responsavel: ${
                  getUserNode().nome
                } | Aluno: ${aluno.nome} | Aluno ID: ${
                  pedido.data.data.id_pessoa
                }</li>`;
                corpoEmail.push(li);
              });
              api.post("mail/sendList", {
                model: 150,
                context: {},
                assunto: `Gerado novo link de pagamento`,
                email: "financeiro@voitto.com.br",
                cc: "comercial@voitto.com.br",
                list: corpoEmail.join(""),
              });

              setPedidoGerado(true);
            })
            .catch((error) => {
              swal(
                "Ops :(",
                `Houve um erro ao criar um registro de inscrição do curso, informe ao TI imediatamente`,
                "error",
              );
              console.log("error pc create", error);
              return true;
            });

          const logs = {
            local: `admin/pagamentos/gerar/${aluno.id}`,
            texto: `Gerou um link de pagamento do(s) curso(s) (${JSON.stringify(
              cursos,
            )}) para o aluno (${aluno.id}[${
              aluno.email
            }]) no valor de: ${valorTotal}R$ - ID DO PEDIDO: ${pedido_id_recent}`,
          };
          await api.post("/admin/log/register", {
            actions: `Gerou um link de pagamento do(s) curso(s) (${nameCourses.join(
              ", ",
            )}) para o aluno (${aluno.nome}[${
              aluno.email
            }]) no valor de: ${valorTotal}R$ - ID DO PEDIDO: ${pedido_id_recent}`,
          });
        })
        .catch(() => {
          swal(
            "Ops :(",
            "Houve um erro ao criar o pedido, informe ao TI imediatamente",
            "error",
          );
        });
    } catch (error) {
      swal(
        "Ops :(",
        `Houve um erro ao pegar os nomes dos cursos para o email, informe ao TI imediatamente`,
        "error",
      );
      const logs = {
        local: `admin/pagamentos/gerar/${aluno.id}`,
        texto: `Tentou gerar um link de pagamento do(s) curso(s) (${cursos}) para o aluno (${aluno.id}[${aluno.email}]) - Erro: ${error}`,
      };
      await api.post("system_logs", {
        acao: JSON.stringify(logs),
      });
    }
  }, [cursos, pedidoJsonCreate, checkIncompany, metodo, aluno, conferirCadastro]);

  const handleCursos = useCallback(
    (index, payload) => {
      const newCursos = [...cursos];
      newCursos[index] = payload;

      const newPedidoTipo = newCursos
        .map((newCurso) => newCurso["link-item"])
        .includes(true)
        ? 6
        : 5;

      setPedidoTipo(newPedidoTipo);

      setCursos(newCursos);
    },
    [cursos],
  );

  const addCurso = useCallback(
    (options) => {
      const firstOption = options[0];

      const defaultCurso = {
        id: firstOption.value,
        "link-item": false,
        material: false,
        certificado: false,
        valor: 0,
      };
      setCursos((cursos) => [...cursos, defaultCurso]);
    },
    [cursosOptions],
  );

  const getAluno = (id) => {
    api
      .get(`/alunos/${id}`)
      .then((res) => {
        setAluno(res.data.aluno);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const loadCursosOptions = useCallback(async () => {
    try {
      // const params = {
      //   all: 1,
      // };

      const response = await api.get("curso/area");
      const newCursosOptions = response.data
        //redundant
        .filter((elem) => elem.listar === 1)
        .map(({ titulo, id }) => ({
          label: titulo + " - " + id,
          value: id,
        }));

      setCursosOptions(newCursosOptions);

      if (!cursos.length) {
        addCurso(newCursosOptions);
      }
    } catch (err) {
      console.error(err);
    }
  }, [cursos]);

  useEffect(() => {
    loadCursosOptions();
  }, []);

  useEffect(() => {
    const { id_pessoa } = router.query;

    getAluno(id_pessoa);
  }, [router]);

  function handleDataValidadeChange(data) {
    setIsNotDataValidade(data.isNotDataValidade);
    if (!data.isNotDataValidade) {
      if (data.dataValidade && new Date(data.dataValidade) < new Date()) {
        swal(
          "Data de validade do link de pagamento inválida pois está no passado",
          `Por favor, informe uma data de validade posterior`,
          "error",
        );
        return;
      }
      const formattedDate = convertDateToInputDateTimeLocal(new Date(data.dataValidade));
      setDataValidade(formattedDate);
    }
  }

  function handleDataValidadeCursoChange(data) {
    if (data.dataValidadeCurso) {
      setDataValidadeCurso(data.dataValidadeCurso);
    }
  }

  function handleParcelsLimitChange(data) {
    setParcelsLimit(Number(data.parcelsLimit));
  }

  const handleTotal = (value) => {
    setValorTotal(value);
  };

  const handleEmail = async () => {
    const nameCourses = await returnNamesCourses();

    api
      .post("mail/send", {
        model: 20,
        context: {
          nome: aluno.nome,
          curso: nameCourses,
          hashcode: codigoLink ? `${idPedido}?c=${codigoLink}` : idPedido,
        },
        assunto: `Link de pagamento para realizar sua inscrição`,
        nome: aluno.nome,
        email: aluno.email,
        cc: "comercial@voitto.com.br,financeiro@voitto.com.br,",
      })
      .then(() => {
        swal(
          "Sucesso!",
          `O link de pagamento foi enviado para o usuário!`,
          "success",
        );
        try {
          // ... log
        } catch (error) {}
      })
      .catch(() => {
        swal(
          "Ops :(",
          `Houve um erro ao enviar o email do link de pagamento, informe ao TI imediatamente`,
          "error",
        );
        return true;
      });
  };

  return (
    <Box width="100%" paddingLeft="250px">
      <Box width="100%" padding="1rem">
        <AdminMenu />

        <Content>
          <Title>Gerar link de pagamento</Title>

          <Form
            template={FormTemplateAdmin}
            setAluno={setAluno}
            aluno={aluno}
            fields={[
              [
                {
                  label: "ID",
                  name: "id",
                  initialValue: aluno.id,
                  readOnly: true,
                },
                {
                  label: "Name",
                  name: "name",
                  initialValue: aluno.nome,
                  readOnly: true,
                },
                {
                  label: "Email",
                  name: "email",
                  initialValue: aluno.email,
                  readOnly: true,
                },
              ],
              [
                {
                  label: "CPF/CNPJ",
                  name: "cpf",
                  initialValue: aluno.cpf,
                  mask: true,
                  readOnly: false,
                },
                {
                  label: "Celular",
                  name: "celular",
                  initialValue: aluno.celular,
                  readOnly: false,
                },
              ],
              [
                {
                  label: "CEP",
                  name: "cep",
                  initialValue: aluno.cep,
                  readOnly: false,
                },
                {
                  label: "Endereço",
                  name: "endereco",
                  initialValue: aluno.endereco,
                  readOnly: false,
                },
                {
                  label: "Número",
                  name: "numero",
                  initialValue: aluno.numero,
                  readOnly: false,
                },
              ],
              {
                label: "Bairro",
                name: "bairro",
                initialValue: aluno.bairro,
                readOnly: false,
              },
              [
                {
                  label: "Cidade",
                  name: "cidade",
                  initialValue: aluno.cidade,
                  readOnly: false,
                },
                {
                  label: "Estado",
                  name: "estado",
                  initialValue: aluno.estado,
                  readOnly: false,
                },
              ],
            ]}
          />

          <Title>Dados do Pedido</Title>

          <CursosContainer>
            {cursos.map((curso, index) => (
              <FormContainer key={index}>
                <h3>Curso {index + 1}</h3>
                <Form
                  template={FormTemplateAdmin}
                  fields={[
                    {
                      label: "Id do Curso",
                      name: "id",
                      type: "select-curso",
                      initialValue: curso["id"] || false,
                    },
                    {
                      label: "Será enviado algum sub-item?",
                      type: "checkboxes",
                      choices: [
                        {
                          label: "Material",
                          name: "material",
                          initialValue: curso["material"] || false,
                        },
                        {
                          label: "Certificado",
                          name: "certificado",
                          initialValue: curso["certificado"] || false,
                        },
                      ],
                    },
                    {
                      label:
                        "Esse link é direcionado somente para a compra de material e/ou certificado?",
                      type: "checkboxes",
                      choices: [
                        {
                          label: "Sim",
                          name: "link-item",
                          initialValue: curso["link-item"] || false,
                        },
                      ],
                    },
                  ]}
                  changeCallback={(payload) => handleCursos(index, payload)}
                />
              </FormContainer>
            ))}
          </CursosContainer>

          <TextValue>
            <p>Valor total do pedido:</p>
            <input
              value={valorTotal}
              onChange={(e) => {
                const valorSemPonto = e.target.value.replace(/\./g, "");
                setValorTotal(valorSemPonto);
              }}
            />
          </TextValue>

          <h3>Escolher plataforma específica</h3>
          <PaymentContainer>
            <CardsContainer>
              <Card
                active={metodo == "cartao_de_credito"}
                onClick={() => setMetodo("cartao_de_credito")}
              >
                <div>
                  <Icon size="huge" name="credit card outline" />
                </div>
                <p>Cartão de Crédito</p>
              </Card>
              <Card active={metodo == "pix"} onClick={() => setMetodo("pix")}>
                <div>
                  <AmeIcon src="https://files.voitto.com.br/logos/logopix.png" />
                </div>
                <p>PIX</p>
              </Card>
              <Card
                active={metodo == "paypal"}
                onClick={() => setMetodo("paypal")}
              >
                <div>
                  <CgPaypal size="4em" color="#012169" />
                </div>
                <p>PayPal</p>
              </Card>
            </CardsContainer>

            <span onClick={() => setMetodo("escolha")}>
              <input type="checkbox" checked={metodo === "escolha"} />
              Todas as opções
            </span>
          </PaymentContainer>
          <h3>Válidade do link de pagamento</h3>
          <FormContainer key={"validade_pagamento"}>
            <Form
              template={FormTemplateAdmin}
              fields={[
                {
                  type: "checkboxes",
                  choices: [
                    {
                      label: "Sem data de válidade(link sem expiração)",
                      name: "isNotDataValidade",
                      initialValue: isNotDataValidade,
                    },
                  ],
                },
                {
                  name: "dataValidade",
                  type: "datetime-local",
                  readOnly: isNotDataValidade,
                  initialValue: convertDateToInputDateTimeLocal(dataValidade),
                },
              ]}
              changeCallback={handleDataValidadeChange}
            />
          </FormContainer>

          <h3 style={{gap: '0.5rem', display: 'flex'}}>
            Validade do acesso ao curso diferente?
            <input
              type="checkbox"
              id="isCustomCourseValidity"
              checked={isCustomCourseValidity}
              onChange={(e) => {
                setIsCustomCourseValidity(e.target.checked);
                if (!e.target.checked) {
                  setDataValidadeCurso(null);
                }
              }}
            />
          </h3>

          {isCustomCourseValidity && (
            <FormContainer key={"validade_curso"}>
              <Form
                template={FormTemplateAdmin}
                fields={[
                  {
                    type: "checkboxes",
                    choices: [
                      {
                        label: "Acesso Vitalício (Sem expiração)",
                        name: "isNotDataValidadeCurso",
                        initialValue: isNotDataValidadeCurso,
                      },
                    ],
                  },
                  !isNotDataValidadeCurso && {
                    name: "dataValidadeCurso",
                    type: "date",
                    readOnly: isNotDataValidadeCurso,
                    initialValue: dataValidadeCurso,
                  },
                ].filter(Boolean)}
                changeCallback={(data) => {
                  setIsNotDataValidadeCurso(data.isNotDataValidadeCurso);
                  handleDataValidadeCursoChange(data);
                }}
              />
            </FormContainer>
          )}

          {["escolha", "cartao_de_credito"].includes(metodo) && (
            <>
              <h3>Limite de parcelas</h3>
              <FormContainer key={"parcela"}>
                <Form
                  template={FormTemplateAdmin}
                  fields={[
                    {
                      name: "parcelsLimit",
                      type: "select",
                      initialValue: { parcelsLimit },
                      options: creditCardInstallments,
                    },
                  ]}
                  changeCallback={handleParcelsLimitChange}
                />
              </FormContainer>
            </>
          )}

          {pedidoGerado && (
            <Button onClick={handleEmail}>Enviar o email para o usuário</Button>
          )}

          <Button positive onClick={() => setModalOpen(true)}>
            Abrir pedido
          </Button>

          <Modal active={modalOpen} handler={() => setModalOpen(false)}>
            <HeaderModal handler={() => setModalOpen(false)}>
              <i>
                <FaAddressCard size={24} />
              </i>
              <h2>Dados do pedido</h2>
            </HeaderModal>

            <main>
              <li>
                <label>Total</label>
                <input value={valorTotal} disabled />
              </li>
              <li>
                <label>Cursos</label>
                <input value={`${cursos.map((item) => item.id)}`} disabled />
              </li>
              <li>
                <label>Método</label>
                <input
                  value={metodo === "escolha" ? "Todas as opções" : metodo}
                  disabled
                />
              </li>
              <li>
                <label>Validade Pagamento</label>
                <input
                  value={
                    isNotDataValidade
                      ? "Link sem data de válidade"
                      : new Date(dataValidade).toLocaleString("pt-BR")
                  }
                  disabled
                />
              </li>
            </main>

            <FooterModal>
              <ModalButton color="#d00" row onClick={() => setModalOpen(false)}>
                <i>
                  <CgClose />
                </i>
                <span>Fechar</span>
              </ModalButton>
            </FooterModal>
          </Modal>

          <Button positive onClick={gerarLink}>
            Gerar pagamento
          </Button>
        </Content>
      </Box>
    </Box>
  );
};

export default Pagamentos;
